// @flow
import React, { Component, Fragment } from "react";
import classNames from "classnames";
import InputAdornment from "@material-ui/core/InputAdornment";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputBase from "@material-ui/core/InputBase";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";
import StyledTextField from "./StyledTextField";
import TextReplaceHelper from "./utils/TextReplaceHelper";

const styles = (theme: DictionaryType): DictionaryType => ({
  rootShow: {
    display: "block"
  },
  rootHide: {
    display: "none"
  },
  select: {
    width: 0,
    height: 0,
    minWidth: 0,
    maxWidth: 0,
    minHeight: 0,
    maxHeight: 0,
    cursor: "none"
  }
});

type TextReplacableInputPropsType = {
  classes: {
    rootShow: DictionaryType,
    rootHide: DictionaryType,
    select: DictionaryType
  },
  label: string,
  name: string,
  value: string,
  isRequired: boolean,
  syncChange: Function,
  rows?: number,
  startAdornment?: React$Element<*>
};

type TextReplacableInputStatesType = {
  modal: boolean
};

class TextReplacableInput extends Component<
  TextReplacableInputPropsType,
  TextReplacableInputStatesType
> {
  constructor(props: TextReplacableInputPropsType) {
    super(props);
    this.state = {
      modal: false
    };
  }

  handleOpen = () => {
    this.setState({ modal: true });
  };

  handleClose = () => {
    this.setState({ modal: false });
  };

  handleChange = (e: SyntheticInputEvent<*>): * => {
    const name = e.target.name;
    const value = e.target.value;

    const element = document.getElementById(this.props.name);
    const startPosition = element.selectionStart;

    if (
      startPosition > 1 &&
      value[startPosition - 1] === "[" &&
      value[startPosition - 2] === "["
    ) {
      this.handleOpen();
    }

    this.props.syncChange(this.props.name, value);
  };

  syncChange = (e: SyntheticInputEvent<*>): Function => {
    const element = document.getElementById(this.props.name);
    const startPosition = element.selectionStart;

    const text = this.props.value;
    const preText = text.substring(0, startPosition);
    let afterText = text.substring(startPosition);

    let delayLength = 2;
    if (afterText < 2 || afterText[0] !== "]" || afterText[1] !== "]") {
      afterText = "]] " + afterText;
      delayLength = 3;
    }

    const final = preText + e.target.value + afterText;
    this.props.syncChange(this.props.name, final, (): * => {
      element.selectionEnd =
        startPosition + e.target.value.length + delayLength;
    });
  };

  render(): React$Element<*> {
    const classes = this.props.classes;

    const TextHelper = this.props.helperComponent;

    return (
      <Fragment>
        <StyledTextField
          isRequired={this.props.isRequired}
          label={this.props.label}
          name={this.props.name}
          value={this.props.value}
          onChange={this.handleChange}
          inpuType="text"
          {...(this.props.rows ? { rows: this.props.rows } : {})}
          endAdornment={
            <InputAdornment position="end">
              <TextReplaceHelper />
            </InputAdornment>
          }
          startAdornment={this.props.startAdornment}
        />
        <Select
          open={this.state.modal}
          onClose={this.handleClose}
          onOpen={this.handleOpen}
          value=""
          onChange={this.syncChange}
          inputProps={{
            name: this.props.name
          }}
          classes={{
            root: classNames(
              this.state.modal && classes.rootShow,
              !this.state.modal && classes.rootHide
            ),
            select: classes.select
          }}
          input={<InputBase />}
        >
          <MenuItem value="Person">Person</MenuItem>
          <MenuItem value="Time">Time</MenuItem>
          <MenuItem value="AlertName">AlertName</MenuItem>
          <MenuItem value="Probability">Probability</MenuItem>
        </Select>
      </Fragment>
    );
  }
}

export default withStyles(styles)(TextReplacableInput);
